import React from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import "../dashboard/Dashboard.css";
// import "../../pages/academyHome/AcademyHome.css"

const COLORS = ["#3b82f6", "#f59e0b"];

const VisibilityPieChart = ({ data = [], title = " Search Ratio" }) => {
  return (
    <div className="home-analysis-card pie-card">
      <div className="home-chart-title">{title}</div>
      <div style={{ height: 340 }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="48%"
              innerRadius={75}
              outerRadius={115}
              dataKey="value"
              animationDuration={1200}
              animationBegin={300}
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index]} />
              ))}
            </Pie>
            <Tooltip />
            <Legend 
              verticalAlign="bottom" 
              iconType="circle"
              wrapperStyle={{ paddingTop: '20px' }}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>

    </div>
  );
};

export default VisibilityPieChart;